import { encodeValue } from '@shared/routes';
import { DateTime } from 'luxon';

// If serializeQuery is not used, this can be used as a per-value encoder for query params
export function appEncodeValue(value: unknown): string {
  // Handle app-specific types first
  if (value instanceof DateTime) {
    return encodeURIComponent(value.toUTC().toISO() ?? String(value));
  }

  // Delegate all other types to the core encodeValue function
  return encodeValue(value);
}
